module.exports = __webpack_public_path__ + "img/reno-chauffage.b19a0618.svg";